import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ComponentBase } from 'src/app/components/core/_infrastructure/classes/componentBase';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { FormGroup, Validators } from '@angular/forms';
import { SolicitudExViewModel } from '../solicitudesex.types';
import { Tc } from '../../../../core/_infrastructure/types/common';
import { DatePipe } from '@angular/common';
import { TInterValoHoraPuntoInspeccionViewModel } from '../../puntosinspeccion/puntoinspeccion.types';
import { EnumIdsTcEstadoSolicitudEx, EnumIdsTcTipoSolicitudEx } from '../../../../_exportacion/solicitudes/types/enum';
import { ReasignacionPcfViewModel } from '../../../../_exportacion/solicitudes/inspecciones/inspeccionesEx.types';

@Component({
    selector: 'app-solicitudesex-edit',
    templateUrl: './solicitudesex-edit.component.html',
})
export class SolicitudesexEditComponent extends ComponentBase implements OnChanges, OnInit {
    @Input() solicitudEx: SolicitudExViewModel;
    @Input() formGroup: FormGroup;
    @Input() estadoSolicitudEx: Tc[];
    @Input() reasignacionPcf: ReasignacionPcfViewModel;

    @Input() listPuntoInspeccion = [];
    @Input() listUbicacion: Tc[] = [];
    @Input() listHoras: TInterValoHoraPuntoInspeccionViewModel[] = [];
    @Input() listInstalacionAutorizada: Tc[] = [];
    @Input() aplicaDocumentacionUk: boolean;

    @Output() onChangePuntoInspeccion = new EventEmitter<number | null>();

    isCollapsedDatosSolicitud = false;
    isCollapsedEstado = false;
    hasChangesHandled: boolean = false;
    tipoSolicitud: number;

    habilitarVentanaReasignacionPcf = false;

    campoUbicacion = true;
    campoInstalacion = true;
    @Input() onAplica$: EventEmitter<boolean>;

    constructor(
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private datepipe: DatePipe,
    ) {
        super(authService, notificationService, exceptionHandler);
    }

    ngOnInit(): void {
        this.updateForm();

        this.onAplica$.subscribe(res => {
            this.updateAplicaDocumentacionUk(res);
        });

        this.form.get('IdTipoSolicitudEx')?.valueChanges.subscribe(value => {
            this.tipoSolicitud = value;
        });

        // Suscribirse a los cambios en el valor de 'IdEstadoSolicitudEx'
        this.form.get('IdEstadoSolicitudEx')?.valueChanges.subscribe(value => {
            this.toggleFields(value);
        });

        if (this.form.controls['IdUbicacion'].value != null) {
            this.campoUbicacion = true;
            this.campoInstalacion = false;
        } else {
            this.campoUbicacion = false;

            if (this.form.controls['IdInstalacionAutorizada'].value != null) {
                this.campoInstalacion = true;
            }
        }
    }

    toggleFields(value: number): void {
        this.habilitarVentanaReasignacionPcf =
            this.esEstadoValido(value) && this.aplicaDocumentacionUk && this.tipoSolicitud == EnumIdsTcTipoSolicitudEx.ID_TERCER_PAIS;
    }

    esEstadoValido(estado: number): boolean {
        return (
            estado === EnumIdsTcEstadoSolicitudEx.ID_BORRADOR ||
            estado === EnumIdsTcEstadoSolicitudEx.ID_NUEVA ||
            estado === EnumIdsTcEstadoSolicitudEx.ID_EN_TRAMITE ||
            estado === EnumIdsTcEstadoSolicitudEx.ID_REVISION_SOLICITANTE ||
            estado === EnumIdsTcEstadoSolicitudEx.ID_REVISADO_SOLICITANTE
        );
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.solicitudEx?.currentValue) {
            this.solicitudEx = { ...changes.solicitudEx.currentValue };
            this.updateForm();
            this.toggleFields(this.solicitudEx.IdEstadoSolicitudEx);
        }

        if (this.solicitudEx && this.reasignacionPcf && !this.hasChangesHandled) {
            this.updateForm();

            this.toggleFields(this.solicitudEx.IdEstadoSolicitudEx);
            // Marcar que ya se manejó este cambio
            this.hasChangesHandled = true;
        }

        if (changes?.estadoSolicitudEx?.currentValue) {
            this.form.get('IdEstadoSolicitudEx')?.enable();
        }

        if (changes?.aplicaDocumentacionUk && this.form) {
            const estadoValue = this.form.get('IdEstadoSolicitudEx')?.value;
            if (estadoValue !== undefined) {
                this.toggleFields(estadoValue);
            }
        }
    }

    updateAplicaDocumentacionUk(value: boolean): void {
        this.aplicaDocumentacionUk = value;
        this.toggleFields(this.form.get('IdEstadoSolicitudEx')?.value); // Recalcular habilitarVentanaReasignacionPcf si es necesario
    }

    /**
     * This functions sets the values in the solicitudesex (@Input) into the form.
     */
    private updateForm(): void {
        this.formGroup.setValue({
            CodigoSolicitudEx: this.solicitudEx?.Codigo || '',
            NumeroCertificadoEx: this.solicitudEx?.NumeroCertificado || '',
            IdEstadoSolicitudEx: this.solicitudEx?.IdEstadoSolicitudEx || null,
            FechaEnvio: this.datepipe.transform(this.solicitudEx?.FechaEnvio, 'dd/MM/yyyy') || null,
            IdPuntoInspeccion: this.reasignacionPcf?.IdPuntoInspeccion || null,
            IdUbicacion: this.reasignacionPcf?.IdUbicacion || null,
            IdInstalacionAutorizada: this.reasignacionPcf?.IdInstalacionAutorizada || null,
            IdIntervaloHoras: this.reasignacionPcf?.IdIntervaloHoras || null,
            IdTipoSolicitudEx: this.solicitudEx?.IdTipoSolicitudEx || null,
        });

        this.form = this.formGroup; // componentBase uses this.form

        this.form.get('IdInstalacionAutorizada')?.disable();
        this.form.get('IdIntervaloHoras')?.disable();
        this.form.get('IdUbicacion')?.disable();

        if (this.form.controls['IdUbicacion'].value != null) {
            this.campoUbicacion = true;
            this.campoInstalacion = false;
        } else {
            this.campoUbicacion = false;

            if (this.form.controls['IdInstalacionAutorizada'].value != null) {
                this.campoInstalacion = true;
            }
        }
    }

    onSelectPuntoInspeccion() {
        const idPuntoInspeccion = this.form.controls['IdPuntoInspeccion'].value;
        this.onChangePuntoInspeccion.emit(idPuntoInspeccion);

        this.form.patchValue({
            IdUbicacion: null,
            IdInstalacionAutorizada: null,
        });

        this.form.controls['IdInstalacionAutorizada'].enable();
        this.form.controls['IdUbicacion'].enable();
        this.form.controls['IdIntervaloHoras'].reset();
        this.form.controls['IdIntervaloHoras'].enable();
        this.campoInstalacion = true;
    }

    onSelectUbicacion() {
        if (this.form.controls['IdUbicacion'].value === null) {
            this.form.controls['IdInstalacionAutorizada'].enable();
            this.form.controls['IdIntervaloHoras'].enable();
            this.addValidator('IdInstalacionAutorizada', Validators.required);
            this.campoInstalacion = true;
        } else {
            this.form.controls['IdInstalacionAutorizada'].disable();
            /*          this.form.controls['IdIntervaloHoras'].disable();*/
            this.removeValidators('IdInstalacionAutorizada');
            this.form.controls['IdInstalacionAutorizada'].reset();
            this.form.controls['IdIntervaloHoras'].reset();
            this.campoInstalacion = false;
        }
    }

    onSelectInstalacionAutorizada() {
        if (this.form.controls['IdInstalacionAutorizada'].value === null) {
            this.form.controls['IdUbicacion'].enable();
            this.addValidator('IdUbicacion', Validators.required);
            this.campoUbicacion = true;
        } else {
            this.form.controls['IdUbicacion'].disable();
            this.removeValidators('IdUbicacion');
            this.form.controls['IdUbicacion'].reset();
            this.campoUbicacion = false;
        }
        this.form.controls['IdIntervaloHoras'].reset();
    }
}
